export default "__VITE_PUBLIC_ASSET__7c1678b4__"